import type { Login } from 'models';
import { useTranslation } from 'react-i18next';

import { Button, CheckboxInput, Col, Form, Icon, Input, Link, PasswordInput, Row, Section, Text } from 'ui';

type LoginFormValues = {
  email: string;
  password: string;
  remember: boolean;
};

type P<T> = {
  loading: boolean;
  onNavigateToPrimaryLogin: () => void;
  onSubmit: (data: Login) => void;
  state: T | undefined;
};

const LoginForm = <T,>({ loading, onNavigateToPrimaryLogin, onSubmit, state }: P<T>) => {
  const [form] = Form.useForm();
  const { t } = useTranslation();

  const onFinish = (data: LoginFormValues) => {
    onSubmit(data);
  };

  return (
    <Form<LoginFormValues> form={form} initialValues={{ remember: true }} onFinish={onFinish}>
      <Form.Item<LoginFormValues>
        label="Email"
        name="email"
        rules={[
          {
            type: 'email',
          },
          {
            required: true,
            whitespace: true,
          },
        ]}
      >
        <Input autoComplete="email" />
      </Form.Item>
      <PasswordInput
        item={{
          className: 'login-form__password',
          label: 'Password',
          name: 'password',
          rules: [
            {
              required: true,
              whitespace: true,
            },
          ],
        }}
      />
      <Row align="middle" justify="center">
        <Col span={12}>
          <CheckboxInput
            item={{
              label: t('Remember me'),
              name: 'remember',
              valuePropName: 'checked',
            }}
          />
        </Col>
        <Col className="onboarding-password-login-form__forgot-link" span={12}>
          {/* TODO type of state should be sent to Link */}
          <Text>
            <Link state={state} to={{ pathname: '/forgot-password' }}>
              Forgot password?
            </Link>
          </Text>
        </Col>
      </Row>
      <Section lineBottom={false} lineTop={false} paddingBottom={false} paddingTop>
        <Row gutter={[0, 'ms']}>
          <Col span={24}>
            <Button block htmlType="submit" loading={loading} type="primary">
              Log in
            </Button>
          </Col>
          <Col span={24}>
            <Button
              block
              icon={<Icon icon="arrow-left-line" />}
              onClick={() => {
                onNavigateToPrimaryLogin();
              }}
            >
              All log in options
            </Button>
          </Col>
        </Row>
      </Section>
    </Form>
  );
};

export default LoginForm;
